"use client";

// Vereinswechsler in der Kopfzeile: wer in mehreren Vereinen Zugang hat,
// wechselt hier. Der Verein ist der Mandant — gewechselt wird spaeter per
// Server Action (`User.lastClubId`), in der Maskenphase nur angezeigt.
import { useRouter } from "next/navigation";
import { Check, ChevronsUpDown, Plus } from "lucide-react";
import { DropdownMenu, DropdownItem, DropdownLabel, DropdownSeparator } from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import type { ClubView } from "@/lib/views";

function Kuerzel({ club, className }: { club: ClubView; className?: string }) {
  return (
    <span
      className={cn(
        "bg-accent-subtle text-accent grid h-7 w-7 shrink-0 place-items-center rounded-md text-[11px] font-semibold",
        className,
      )}
    >
      {club.initials}
    </span>
  );
}

export function ClubSwitch({ club, clubs }: { club: ClubView; clubs: ClubView[] }) {
  const router = useRouter();
  return (
    <DropdownMenu
      align="left"
      trigger={
        <button
          type="button"
          className="hover:bg-bg-secondary duration-fast flex min-w-0 items-center gap-2.5 rounded-lg py-1 pr-2 pl-1 transition-colors"
          aria-label="Verein wechseln"
        >
          <Kuerzel club={club} />
          <span className="text-body-md text-text-primary hidden truncate font-semibold tracking-tight sm:inline">
            {club.shortName ?? club.name}
          </span>
          <ChevronsUpDown className="text-text-tertiary h-3.5 w-3.5 shrink-0" aria-hidden />
        </button>
      }
    >
      <DropdownLabel>Deine Vereine</DropdownLabel>
      {clubs.map((c) => (
        <DropdownItem key={c.id}>
          <span className="flex w-full items-center gap-2.5">
            <Kuerzel club={c} className="h-6 w-6 text-[10px]" />
            <span className="min-w-0 flex-1">
              <span className="text-body-sm text-text-primary block truncate">{c.name}</span>
              <span className="text-caption text-text-tertiary block">
                <span className="tabular-nums">{c.memberCount}</span> Mitglieder
                {c.city ? ` · ${c.city}` : ""}
              </span>
            </span>
            {c.id === club.id && <Check className="text-accent h-4 w-4 shrink-0" aria-hidden />}
          </span>
        </DropdownItem>
      ))}
      <DropdownSeparator />
      <DropdownItem onClick={() => router.push("/verein-anlegen")}>
        <Plus className="text-text-tertiary h-4 w-4" aria-hidden />
        Weiteren Verein anlegen
      </DropdownItem>
    </DropdownMenu>
  );
}
